module.exports = __webpack_public_path__ + "assets/img/weerweima.0c570569.png";